module.exports = __webpack_public_path__ + "img/code.3b20164f.png";